export default "__VITE_ASSET__$sjkPlRk__"